import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const ActivityCodeFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "text",
                        "name": "code",
                        "label": "Codigo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 2
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR)
                        .length(6, "Se permite solo 6 caracteres para este codigo")
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "title",
                        "label": "Nombre",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "activo",
                        "label": "Activo",
                        "sizing": {
                            "sm": {
                                "offset": "2"
                            }
                        },
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "default",
                        "label": "Actividad por defecto",
                        "sizing": {
                            "sm": {
                                "offset": "2"
                            }
                        },
                    },
                ],
            ]
        }
    ],
};


export default ActivityCodeFormConfig;